import React from 'react'
import { resolveMediaUrl } from 'utils/Network'

function ExplorePostHeader({post}) {
  const avatar = post.user.profile?.avatar
  return (
    <div className="feed-post-header">
        <img className="rounded-circle user-logo" width="40" height="40" alt="" src={ avatar ? resolveMediaUrl(avatar) : "/assets/images/user.png"}></img>
        <h2>{post.user.profile.first_name} {post.user.profile.last_name}</h2>
    </div>
  )
}

export default ExplorePostHeader
